import { useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "./AppContext";
import styles from './ChatFrame.module.css';

const CHAT_BASE_URL = "https://bot.app.edulla.ai";
const CHAT_INDEX_PATH = "/index.html";

const buildIframeUrl = (lastLocation: unknown, tid: string): string => {
  const sanitizedPath = (() => {
    if (typeof lastLocation !== "string") {
      return CHAT_INDEX_PATH;
    }

    const trimmed = lastLocation.trim();

    if (!trimmed || trimmed === "/" || trimmed === "undefined" || trimmed === CHAT_INDEX_PATH) {
      return CHAT_INDEX_PATH;
    }

    return trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  })();

  const url = new URL(sanitizedPath, CHAT_BASE_URL);

  if (tid) {
    url.searchParams.set("tid", tid);
  } else {
    url.searchParams.delete("tid");
  }

  return url.toString();
};

function ChatFrame() {
  const { state } = useContext(AppContext);
  const tid = window.sessionStorage.getItem("edullaTid") ?? "";

  const initialSrc = useMemo(() => buildIframeUrl(state.lastLocation, tid), [state.lastLocation, tid]);
  const [iframeSrc, setIframeSrc] = useState(initialSrc);

  useEffect(() => {
    setIframeSrc(buildIframeUrl(state.lastLocation, tid));
  }, [state.lastLocation, tid]);

  const isChatVisible = state.showChat;

  const wrapperClassName = `${styles.chatFrameWrapper} ${isChatVisible ? styles.chatFrameWrapperShow : styles.chatFrameWrapperHidden}`;
  const isHidden = !isChatVisible;
  const ariaHidden = isHidden || undefined;
  const iframeTabIndex = isHidden ? -1 : undefined;

  return (
    <div className={wrapperClassName} aria-hidden={ariaHidden} hidden={isHidden}>
      <iframe
        className={styles.chatFrame}
        src={iframeSrc}
        id="edullaChatWidgetFrame"
        title="Chat"
        tabIndex={iframeTabIndex}
        aria-hidden={ariaHidden}
        hidden={isHidden}
      ></iframe>
    </div>
  );
}

export default ChatFrame;
